module.exports = __webpack_public_path__ + "static/whatareyouwaitingfor-ef510fd5dac45bc10952bceabf741ac4.png";